import { EndOfJourneyScanItem } from '../../lib/types/models/end-of-journey-scan/end-of-journey-scan'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

// Sends a failed (or stuck) questionnaire to be read again; force: replace the questionnaire already received for the youth
export function retryEndOfJourneyScanItem(input: { id: number; force?: boolean }) {
  return restApiClient
    .url(constructApiUrl(API['end-of-journey-scans'].retryItem.url, { id: input.id }))
    .post<EndOfJourneyScanItem>({ force: input.force ?? false })
}
